import breakpoints from '../lib/breakpoints';

function Toggle() {
  const mediaQuery = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  return {
    isOpen: false,
    toggle(id = 'toggle', $dispatch) {
      this.isOpen = !this.isOpen;
      $dispatch('toggle', { id });
    },
    handleBpChange(e) {
      this.isOpen = e.matches;
    },
    init() {
      this.handleBpChange(mediaQuery);
      // mediaQuery.addEventListener('change', this.handleBpChange);
    },
  };
}

export default Toggle;
